<template>
    <div class="settings">

        <h2>Settings</h2>
        <hr>

        <DealerProfile v-if="can('access-dealer-profile')"/>
        <MyProfile />
    </div>
</template>

<script>
    import DealerProfile  from '@/views/dashboard/tenants/DealerProfile.vue';
    import MyProfile      from '@/views/dashboard/tenants/MyProfile.vue';

    export default {
        name: "Settings",
        components: {
            DealerProfile,
            MyProfile,
        }
    }
</script>

<style scoped lang="scss">
  .settings {
    //   max-width: 1800px;
  }
</style>
